import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"

export interface Category {
  id: string
  name: string
  slug: string
  type: "needs" | "wants" | "investments" | "income" | "transfer"
  icon: string | null
  color: string | null
  isSystem: boolean
  hidden?: boolean
  children: Category[]
}

interface CategoriesResponse {
  success: boolean
  data: Category[]
}

export function useCategories() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: () => api.get<CategoriesResponse>("/categories"),
    staleTime: Infinity,
  })
}

/** Flatten the category tree into a flat list */
export function flattenCategories(cats: Category[]): Category[] {
  const flat: Category[] = []
  for (const cat of cats) {
    flat.push(cat)
    if (cat.children?.length) {
      for (const child of cat.children) {
        flat.push(child)
      }
    }
  }
  return flat
}
